module.exports = __webpack_public_path__ + "img/電気回路_4_3_1.29681ded.png";